export enum CriteriaTreeOperator {
    Single = 0,
    SingleNotCompleted = 1,
    All = 4,
    SumChildren = 5,
    MaxChild = 6,
    CountDirectChildren = 7,
    Any = 8,
    SumChildrenWeight = 9,
}
